import {ProductCategoryModel} from "../../models/productCategory";
import React from "react";
import {ImageUtils} from "../../utils/imageUtils";
import {Image} from "../images/Image";
import {Heading4} from "../text";
import Skeleton from "react-loading-skeleton";
import Link from "next/link";

export interface StoreCategorySectionViewProps {
  categories: ProductCategoryModel[]
  loading: boolean
}

export const StoreCategorySectionView: React.FC<StoreCategorySectionViewProps> = ({ categories, loading }) => {
  return (
    <div
      className="flex flex-row space-x-3 items-center max-w-full no-scrollbar overflow-x-scroll mx-2 md:mx-4 lg:mx-6 mt-4 md:mt-6 lg:mt-8"
    >
      {categories.map((category, index) => {
        const imageUrl = ImageUtils.createUrlFromImage(category.image, { heightPx: 70, widthPx: 70 }) ?? ""
        if (loading) {
          return <Skeleton key={category.id} className="!h-10 !w-28 !lg:h-12 !lg:w-36 !rounded-full" />
        }
        return <Link href={`/store-category/${category.id}`} key={category.id} passHref>
          <a
            className="hover:bg-fg-gray-lighter text-fg-black flex-shrink-0 items-center px-2.5 py-1.5 lg:px-4 lg:py-3 flex flex-row space-x-2 bg-fg-gray-surface rounded-full"
          >
            <Image src={imageUrl} objectFit="contain" alt={category.name} sizeClass="h-7 w-7" className="flex-shrink-0" />
            <Heading4 className="flex-shrink-0 whitespace-nowrap">{category.name}</Heading4>
          </a>
        </Link>
      })}
    </div>
  )
}